module.exports = __webpack_public_path__ + "img/1-lg.6f795d11.jpg";